import {JSONable} from "@irian-ro/abstract-resource";

export class CustomerMetadata extends JSONable {

  partnerBusinessProfileUuid: string | undefined = undefined;

}
